<template>
    <div>
        <top-bar
            activeTab="home"
            :isLogin="isLogin"
            :modalController="modalController"
            ref="top-bar"
            @switchLang="switchLang($event)"
            @logout="logout()"
        ></top-bar>
        <div class="container">
            <h2>{{ name }}</h2>
            <h1>{{ lbl.main.home_page }}</h1>
            <div class="card" v-if="!isLogin">
                <div class="card-body">
                    <div
                        class="text-center mb-2"
                        ref="titletext"
                        id="title-login"
                    >
                        {{ lbl.main.login }}
                    </div>
                    <div class="form-group">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Username"
                            v-model="modelLogin.username"
                        />
                    </div>
                    <div class="form-group">
                        <input
                            type="password"
                            class="form-control"
                            placeholder="Password"
                            v-model="modelLogin.password"
                        />
                    </div>
                    <div class="form-group text-center">
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="login()"
                        >
                            {{ lbl.main.login }}
                        </button>
                        <br /><br />
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="deviceLogin()"
                        >
                            Device Login
                        </button>
                        <br /><br />
                        <router-link to="/register">Register</router-link>
                    </div>
                </div>
            </div>
            <div class="card" v-else-if="isLogin && profile">
                <div class="card-body">
                    <h4>Hello {{ profile.strDisplayName }}</h4>
                    <div>{{ profile.strEmail }}</div>
                </div>
            </div>

            <div class="card mt-5">
                <div class="card-body">
                    <h4>All new Modal</h4>
                    <button
                        class="btn btn-secondary mr-2"
                        @click="clickShowAlert()"
                    >
                        Alert Modal
                    </button>
                    <button
                        class="btn btn-secondary mr-2"
                        @click="clickShowLoading()"
                    >
                        Loadig Modal
                    </button>
                    <button
                        class="btn btn-secondary mr-2"
                        @click="clickShowConfirm()"
                    >
                        Confirm Modal
                    </button>
                </div>
            </div>

            <div>
                <h1>text flex</h1>
                <div class="div-flex">
                    <div class="p-2">Content 1</div>
                    <div class="p-2">Content 2</div>
                    <div class="p-2">Content 3</div>
                    <div class="p-2">Content 4</div>
                </div>
            </div>

            <div>
                {{ textKey }}<br />
                <input type="text" v-model="textKey1" @keyup="onKey1()" /><br />
                <input type="text" v-model="textKey2" @keypress="onKey2()" />
            </div>
        </div>

        <modal-master :controller="modalController"></modal-master>
    </div>
</template>

<script>
// @ is an alias to /src
// import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
import Util from "@/helper/Utility.js";
//component
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import AccountMixin from "@/mixin/AccountMixin.js";
//service
import { TrackingService } from "@/helper/TrackingHelper.js";
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";

export default {
    name: "home",
    components: {
        TopBar
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin, ModalMixin],
    data: function() {
        return {
            isLogin: false,

            name: "Hello",
            modelLogin: {
                username: "aaabbbccc",
                password: "11111111"
            },

            // all new modal
            modalController: null,
            alertModal: null,
            loadingModal: null,
            confirmModal: null,

            tracking: new TrackingService(this),

            point: 0,
            textKey: "test",
            textKey1: "",
            textKey2: ""
        };
    },
    created: function() {
        Account.loginStatus().then(status => {
            this.isLogin = status;
            if (status) {
                // do something
            }
        });

        // this.tracking.screenName("home");
        // this.tracking.event();
        // Vue.ga.screenName(this, 'Home');
        // Vue.ga.event(this, "new cat", "view page", "home label");

        // var obj = JSON.stringify(this.lbl, null, 2);
        // console.log("\x1b[35m%s\x1b[0m", obj);
        var obj = {
            a: 1,
            b: 2,
            c: [1, 2, 3],
            d: {
                x: 1,
                y: 2,
                z: "hello"
            }
        };
        Util.log("print", obj);
        Util.logJson(obj, "red");
        Util.logJson(obj, "green");
        Util.logJson(obj, "blue");

        this.testObserveApi();
    },
    methods: {
        login: function() {
            Account.apiBzbsLogin(
                this.modelLogin.username,
                this.modelLogin.password
            )
                .then(objResult => {
                    this.isLogin = true;
                    // this.profile = objResult.profile;
                    // this.setProfile();
                    console.log(objResult);
                    window.location.reload();
                })
                .catch(error => {
                    console.log(error);
                    this.errorApi(error);
                });
        },
        deviceLogin: function() {
            this.loadingModal.show();
            var uuid = "DEV_307c5e91-2cf2-9065-7465-f5130e43330f";
            Account.apiDeviceLoginWithUUID(uuid)
                .then(() => {
                    this.loadingModal.hide();
                    window.location.reload();
                })
                .catch(err => {
                    this.loadingModal.hide();
                    this.errorResponse(err);
                });
        },

        // all new modal
        clickShowAlert: function() {
            this.alertModal
                .clearModal()
                .setTitle("This is title")
                .setMsg("modal message")
                .setBtnOk("Button ok")
                .setTag("alert-1")
                .show();
            this.alertModal.onClickOk(data => {
                console.log(data);
                console.log("alert ok");
            });
            this.alertModal.onHidden(data => {
                console.log(data);
                console.log("alert hidden");
            });
        },
        clickShowLoading: function() {
            this.loadingModal.show();
        },
        clickShowConfirm: function() {
            this.confirmModal
                .clearModal()
                .setTitle("Header confirm")
                .setMsg("Message Confirm")
                .setBtnOk("YES")
                .setBtnCancel("NO")
                .setTag("test-confirm")
                .show();
            this.confirmModal.onClickOk(data => {
                console.log(data);
                console.log("click confirm");
            });
            this.confirmModal.onClickCancel(data => {
                console.log(data);
                console.log("click cancel");
            });
        },

        testObserveApi: function() {
            var token = Account.getToken();

            BzbsProfile.getPoint(token).subscribe(
                profilePoint => {
                    console.log(profilePoint);
                },
                err => {
                    console.log(err);
                    if (err.id == 401) {
                        console.log("Go login");
                    } else {
                        this.errorResponse(err); // call mixin function
                    }
                }
            );
        },

        onKey1: function() {
            this.textKey = this.textKey1;
        },
        onKey2: function() {
            this.textKey = this.textKey2;
        }
    }
};
</script>
<style lang="scss" scoped>
.div-flex {
    display: flex;
}
</style>
